/* External dependencies */
import { AnyAction } from 'redux';

/* Local dependencies */
import {
  OPEN_SIGN_UP,
  OPEN_LOGIN,
  CLOSE_MODAL,
  OPEN_CHOOSER,
  RESET_TO_CHOOSER,
  OPEN_OTP_SIGN_IN,
  OPEN_OTP_SIGN_UP,
  SET_CHECK_MAIL,
  OPEN_ENTER_PASSWORD,
  OPEN_PASSWORD_RECOVERY,
  OPEN_CHECK_MAIL,
  OPEN_NEW_PASSWORD,
  OPEN_PROFILE_PAGE,
} from './actions';

export interface ModalState {
  isOpen: boolean;
  mode: string;
  currentPage?: string;
  modalOpened?: boolean;
  code: string;
}

const initialState: ModalState = {
  isOpen: false,
  mode: 'chooser',
  code: '',
};

export const modalReducer = (state = initialState, action: AnyAction): ModalState => {
  switch (action.type) {
    case OPEN_SIGN_UP:
      return { ...state, isOpen: true, mode: 'signUp' };

    case OPEN_LOGIN:
      return { ...state, isOpen: true, mode: 'login' };

    case CLOSE_MODAL:
      return { ...state, isOpen: false, mode: 'chooser' };

    case OPEN_CHOOSER:
      return { ...state, isOpen: true, mode: 'chooser' };

    case RESET_TO_CHOOSER:
      return { ...state, mode: 'chooser' };

    case OPEN_OTP_SIGN_IN:
      return { ...state, isOpen: true, mode: 'otpSignIn' };

    case OPEN_OTP_SIGN_UP:
      return { ...state, isOpen: true, mode: 'otpSignUp' };

    case SET_CHECK_MAIL:
      return {
        ...state,
        code: action.payload,
      };

    case OPEN_ENTER_PASSWORD:
      return { ...state, isOpen: true, mode: 'enterPassword' };

    case OPEN_PASSWORD_RECOVERY:
      return { ...state, isOpen: true, mode: 'passwordRecovery' };

    case OPEN_CHECK_MAIL:
      return { ...state, isOpen: true, mode: 'checkMail' };

    case OPEN_NEW_PASSWORD:
      return { ...state, isOpen: true, mode: 'newPassword' };

    case OPEN_PROFILE_PAGE:
      return { ...state, currentPage: 'profile', modalOpened: false };

    default:
      return state;
  }
};
